<script type="ts">
	export let name: string | undefined = undefined;
	export let online: boolean | undefined = undefined;
	export let size = '40px';
</script>

<div
	class="image"
	class:status={online !== undefined}
	class:online
	style="--size: {size};"
>
	{#if name}
		<img alt="{name}'s avatar" src="/strategy/images/avatars/avatar-{name}.jpg" />
	{/if}
</div>

<style lang="scss">
	.image {
		width: var(--size);
		height: var(--size);
		user-select: none;
	}

	.status {
		position: relative;
		&::after {
			content: '';
			position: absolute;
			display: block;
			width: 9px;
			height: 9px;
			border-radius: 50%;
			background-color: var(--demo-bg-60);
			right: 0px;
			bottom: 0px;
			box-shadow: 0 0 0 3px var(--demo-bg-20);
		}
	}

	.online::after {
		background-color: limegreen;
	}

	.image:not(.transparent) {
		img {
			border-radius: 50%;
			width: 100%;
			height: 100%;
		}
	}

	.transparent {
		overflow: hidden;

		width: 48px;
		height: 48px;

		display: flex;
		align-items: center;
		justify-content: center;

		border-radius: 50%;

		padding: 6px;
		align-self: start;
		background-color: var(--avatar-background);
	}

	img {
		height: 77%;
		width: auto;
	}
</style>
